import { makeStyles } from "@material-ui/core/styles";

export const PricingLotDetailsDialogStyles = makeStyles((theme) => ({
    // Dialog Styles
    dialog: {
        minHeight: "500px",
    },
    // Pricing Details Tab Styles
    title: {
        fontSize: "0.8rem",
        color: theme.palette.primary.main,
        fontWeight: 500,
        marginBottom: '1rem',
    },
    subTitle: {
        fontSize: "0.7rem",
        color: theme.palette.grey[500],
        paddingLeft: '1rem',
    },
    // Other Vendor Options Tab Styles
    container: {
        width: "100%",
    },
    vendorOptionsTableContainer: {
        maxHeight: 560,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: 4,
    },
    vendorOptionsTable: {
        boxShadow: "none",
        height: "100%",
        marginTop: '1rem',
        minHeight: 460,
    },
    table: {
        marginTop: theme.spacing(1),
        minWidth: 720,
    },
    tableHead: {
        backgroundColor: theme.palette.grey[100],
    },
    vendorHeaderCell: {
        fontWeight: 600,
        color: theme.palette.text.primary,
        whiteSpace: "nowrap",
    },
    vendorNameCell: {
        minWidth: 230,
    },
    vendorNameWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        width: "100%",
    },
    alternativeChip: {
        backgroundColor: "#eef3f7",
        color: theme.palette.text.secondary,
        height: 20,
        fontSize: "0.65rem",
        border: `1px solid ${theme.palette.grey[400]}`,
        minWidth: 84,
    },
    preferredChip: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        height: 20,
        fontSize: "0.65rem",
        minWidth: 84,
    },
    preferredRow: {
        backgroundColor: "#f7fbff",
    },
    selectButton: {
        minWidth: 64,
        height: 26,
        fontSize: "0.75rem",
        textTransform: "none",
    },
    activeAction: {
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
    },
    activeLabel: {
        fontSize: "0.8rem",
        color: theme.palette.primary.main,
    },
    emptyMessage: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.hint,
    },
    tabContent: {
        paddingTop: '1.5rem',
    },
    detailsGrid: {
        width: "100%",
    },
    detailsLayout: {
        width: "100%",
        display: "flex",
        alignItems: "stretch",
    },
    leftColumn: {
        flex: 1,
        minWidth: 0,
    },
    rightColumn: {
        flex: 1,
        minWidth: 0,
    },
    centerDivider: {
        width: 1,
        backgroundColor: theme.palette.grey[300],
        margin: "0 1.5rem",
    },
    rightPanel: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
    comparisonSection: {
        width: "100%",
    },
    comparisonListScroll: {
        maxHeight: 170,
        overflowY: "auto",
        borderRadius: 4,
    },
    comparisonList: {
        width: "100%",
        backgroundColor: theme.palette.grey[100],
        borderRadius: 4,
    },
    comparisonRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.45rem 0.65rem",
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        "&:last-child": {
            borderBottom: "none",
        },
    },
    comparisonName: {
        fontSize: "0.75rem",
        color: theme.palette.text.primary,
    },
    comparisonValues: {
        display: "flex",
        alignItems: "center",
        gap: "0.8rem",
    },
    comparisonCharge: {
        fontSize: "0.75rem",
        color: theme.palette.text.primary,
        minWidth: "3.7rem",
        textAlign: "right",
    },
    comparisonMargin: {
        fontSize: "0.75rem",
        color: theme.palette.text.secondary,
        minWidth: "2.6rem",
        textAlign: "right",
    },
    comparisonMarginPositive: {
        color: theme.palette.error.main,
    },
    comparisonMarginNegative: {
        color: theme.palette.success.main,
    }
}));
